/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getAllFilterTypesEarlyRequestRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.FilterChirpService',
  rpcName: 'getAllFilterTypes',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA3U8OPlq1lRpwP6LXzGzX8',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};